module.exports = __webpack_public_path__ + "img/banner.07185f0b.png";